import {
  useSidebar,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { LucideProps } from "lucide-react";
import { ForwardRefExoticComponent, RefAttributes } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavigationItem } from "./NavigationItem";

interface Item {
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
  >;
  url: string;
  title: string;
}

interface ItemsProps {
  items: Item[];
}

export const NavigationItems = ({ items }: ItemsProps) => {
  const { open } = useSidebar();
  const location = useLocation();
  return items.map((item) => (
    <SidebarMenuItem key={item.title}>
      {!open && (
        <Tooltip>
          <TooltipTrigger asChild>
            <SidebarMenuButton
              asChild
              isActive={item.url === location.pathname}
            >
              <Link to={item.url}>
                <item.icon />
                <span>{item.title}</span>
              </Link>
            </SidebarMenuButton>
          </TooltipTrigger>
          <TooltipContent side="right">{item.title}</TooltipContent>
        </Tooltip>
      )}
      {open && (
        <SidebarMenuButton asChild isActive={item.url === location.pathname}>
          <NavigationItem item={item} />
        </SidebarMenuButton>
      )}
    </SidebarMenuItem>
  ));
};
